import { defaultDataTransformer } from '@aspectus/resource-commons';
import { createReceiver, createSender } from '@md/resources';
import { prefixAPI } from '@md/api';

const r = (tpl, f = createReceiver) => f(prefixAPI(tpl)).transform(defaultDataTransformer);

export const leads = {
  list: r('/leads/list/{?filters,order_by,limit,offset}'),
  addons: {
    statuses: r('/leads/addons/statuses/'),
    sources: r('/leads/addons/sources/'),
  },
  filters: {
    list: r('/leads/filters/list/'),
    available: r('/leads/filters/list/{?filters}'),
  },
  create: r('/leads/create/', createSender),
  retrieve: r('/leads{/id}/retrieve/'),
  update: r('/leads{/id}/update/', createSender).config('method', 'PUT'),
  historyList: r('/leads/history/list/{?s,filters,order_by,limit,offset}'),
  historyFilters: {
    list: r('/leads/history/filters/list/'),
    available: r('/leads/history/filters/list/{?filters}'),
  },
};

export const comments = {
  list: r('/leads/comments/list/{?filters,order_by,limit,offset}'),
  filters: {
    list: r('/leads/comments/filters/list/'),
    available: r('/leads/comments/filters/list/{?filters}'),
  },
  create: r('/leads/comments/create/', createSender),
};
